import { render, staticRenderFns } from "./nr-project-edit-h5.vue?vue&type=template&id=5534f662&scoped=true"
import script from "./nr-project-edit-h5.vue?vue&type=script&lang=ts"
export * from "./nr-project-edit-h5.vue?vue&type=script&lang=ts"
import style0 from "./nr-project-edit-h5.vue?vue&type=style&index=0&id=5534f662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534f662",
  null
  
)

export default component.exports